const privateModule = {
  namespaced:true,
    state: {
      privateDetailParams:{},//私募详情入参
      detailHeaderInfo:{},//私募详情头部返参
      primaryDetailShare:{},
      fromListToDet:{},//列表进入详情传参
      returnPageUrl:'',//点击返回
      orgListTurnParams:{},//机构跳转传参
      aboutFile:{},//相关文档信息
      isRefreshList:'0',//是否刷新列表
      fundManagerList:[],//基金经理
      investmentStrategyList:[], //投资策略
      showAbleChartFlag:[], //是否可看走势图的产品id
      infoBylpManager: {}, //陆浦管家传过来的信息
    },
    mutations: {
      getPrivateFundInfo(state, data) {
        state.privateDetailParams = data
      },
      getFundHeaderInfo(state, data) {
        state.detailHeaderInfo = data
      },
      getFundManagerList(state, data) {
        state.fundManagerList = [...data]
      },
      getIinvestmentStrategyList(state, data) {
        state.investmentStrategyList = [...data]
      },
      setShowAbleChartFlag(state, data) {
        state.showAbleChartFlag.splice(0,state.showAbleChartFlag.length,...data);
      },
      changePrimaryDetailShare(state, data) {
        state.primaryDetailShare = data
      },
      transDetailParam(state, data) {
        state.fromListToDet = data
      },
      changeReturnUrl(state, data) {
        state.returnPageUrl = data
      },
      changeOrgTurnStatus(state, data) {
        state.orgListTurnParams = data
      },
      changeAboutFile(state, data) {
        state.aboutFile = data
      },
      changePrivateListStatus(state, data) {
        state.isRefreshList = data
      },
      changeInfoBylpManager(state, data) {
        state.infoBylpManager = data
      },
    },
    actions: {
    },
    getters: {
      detailHeaderInfo(state){
        let info = state.detailHeaderInfo
        const {templateSelection,netType,
          productType1,subProductId,subProductCode,subProductIdFirst,subProductCodeFirst} = info
        info.isShowYield = true
        info.isShowNet = true
        info.dataSource = 'detail'
        if(templateSelection == '4'){
          info.isShowYield = info.productYieldDisplayed == '1' ? true : false
          info.isShowNet = info.productNetValueDisplayed == '1' ? true : false
        }
        if(templateSelection == '5' ){
          info.productDescription = info?.productDescription ? '上述产品信息以合同约定为准。' + info.productDescription : '上述产品信息以合同约定为准。'
        }
        if(info.productTraitList){
          let newList = [];
          info.productTraitList.map((item) => {
            if (item) newList.push(item);
          });
          if (newList.length) {
            info.specialText = newList.join(" | ");
            info.specialList = newList;
          } else {
            info.specialText = "";
            info.specialList = [];
          }
        }
        if (netType == "2" && productType1 == "1") {
          //淡水泉产品
          info.infoSubId = subProductIdFirst;
          info.infoSubCode = subProductCodeFirst;
        }else{
          info.infoSubId = subProductId;
          info.infoSubCode = subProductCode;
        }
        return info
      }
    }
  }

export default privateModule
